<template lang="pug">
li.static-partnerItem
  .static-partnerImage
    img.static-partnerImageAdjust(:src='info.rectangleThumbnailUrl' alt="")
  .static-partnerHeadline
    span {{ info.name }}
  .static-partnerSubheadline
    v-clamp(
      autoresize
      :max-lines="2"
    ) {{ isEdu ? info.description.replace(hasMore(info.description)[0],'') : info.description }}
  button.static-partnerButton2(
    v-if='!isEdu || hasMore(info.description)'
    @click="goTo()"
  ) 查看更多
</template>
<script>
import VClamp from "vue-clamp";
import matchUrl from "@/utils/matchUrl";

export default {
  components: {
    VClamp,
  },
  props: {
    info: Object,
    idx: Number,
    type: String,
    isEdu: Boolean,
  },
  methods: {
    hasMore(description) {
      return matchUrl(description) || false;
    },
    goTo() {
      if (this.type == "govPartners") {
        this.$router.push({
          path: "/gov-announces",
        });
      } else if (this.type == "eduPartners") {
        return window.open(
          matchUrl(this.info.description)[1],
          "_blank",
          "noopener"
        );
      } else {
        this.$router.push({
          path: "/partner",
          query: {
            id: this.info.id,
          },
        });
      }
    },
  },
};
</script>
